import { useMutation } from "@tanstack/react-query";
import { fetcher } from "../../../utils/Axios";

async function bannerSeen({ tenantId, hospitalId }: { tenantId?: string; hospitalId?: string }) {
  return fetcher({
    url: "/users/banner-seen",
    method: "POST",
    headers: {
      "x-tenant-id": tenantId,
      "x-hospital-id": hospitalId,
    },
  });
}

function useBannerSeenMutation() {
  return useMutation({
    mutationFn: bannerSeen,
  });
}

export default useBannerSeenMutation; 